import {CardColor} from "./api/CardColor";
import {CardName} from "./api/CardName";
import {Card} from "./Card";

export class CardFactory {

    public static createCard(cardColor: CardColor, cardName: CardName): Card {
        return new Card(cardColor, cardName, CardFactory.getCardValue(cardName));
    }

    private static getCardValue(cardName: CardName): number {
        switch (cardName) {
            case(CardName.ACE):
                return 1;
            case(CardName.TWO):
                return 2;
            case(CardName.THREE):
                return 3;
            case(CardName.FOUR):
                return 4;
            case(CardName.FIVE):
                return 5;
            case(CardName.SIX):
                return 6;
            case(CardName.SEVEN):
                return 7;
            case(CardName.EIGHT):
                return 8;
            case(CardName.NINE):
                return 9;
            case(CardName.TEN):
                return 10;
            case(CardName.JACK):
                return 11;
            case(CardName.QUEEN):
                return 12;
            case(CardName.KING):
                return 13;
            default:
                throw new Error("Card does not exist!");
        }
    }

    private constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/CardFactory.ts